import type { TFunction } from "i18next";
import type { WindowEntryChip } from "./types";

/**
 * Builds the meta line shown under a product name: fabric color, frame color
 * and (for sun protection) the control type, joined with " · ".
 */
export function buildChipMeta(chip: WindowEntryChip, t: TFunction): string {
    const control =
        chip.category === "SUN_PROTECTION" && chip.controlType
            ? chip.controlType === "REMOTE"
                ? t("colorStep.controlType.remote")
                : t("colorStep.controlType.app")
            : null;
    return [chip.fabricColorName, chip.frameColorName, control]
        .filter(Boolean)
        .join(" · ");
}
